import { VerticalFlexbox } from "@src/shared/components/layout/Flexbox";

import { CareProtocolOpportunityHistoryListV2 } from "../../../components/v2";

export function CareProtocolOpportunitiesPageV2() {
  return (
    <VerticalFlexbox className="mx-auto min-h-full w-full max-w-[860px] bg-background px-[18px] pb-8 pt-4">
      <header className="pb-4">
        <h1 className="text-[19px] font-semibold leading-tight tracking-[-0.018em] text-surface-foreground">
          Upload history
        </h1>
        <p className="mt-1 text-[13px] leading-5 text-muted-foreground">
          Recent care gap uploads and the items extracted for each patient.
        </p>
      </header>
      <CareProtocolOpportunityHistoryListV2 />
    </VerticalFlexbox>
  );
}
